export enum MESSAGE_SOURCE {
  ORDER = 1,
  CRM = 2
}
